var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Tooltip',{staticClass:"text",style:({color:_vm.statusCode == "leave" ? "#c3cbd6" : "#464c5b",fontWeight:"900"}),attrs:{"delay":1200,"content":_vm.name}},[_vm._v(" "+_vm._s(_vm.name)+" ")]),_c('div',{staticClass:"tagStyle",style:({background:_vm.bgColor})},[_vm._v(" "+_vm._s(_vm.statusName)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }